import Button from "@lhd/components/Button";
import { IPermissionItem } from "@lhd/types";
import { FormInstance } from "antd/es/form/Form";

export interface ButtonToSubmitProps {
  form: FormInstance;
  isEditing?: boolean;
  permission?: IPermissionItem;
  isUploading?: boolean;
  hasChanged: boolean;
  setHasChanged: (v: boolean) => void;
  dataVersion: number;
}

const ButtonToSubmit = ({
  form,
  isEditing,
  permission,
  isUploading,
  hasChanged,
}: ButtonToSubmitProps) => {
  return (
    <Button
      disabled={!isEditing || !permission?.edit || !hasChanged || !!isUploading}
      label="保存"
      onClick={form.submit}
    />
  );
};

export default ButtonToSubmit;
